module.exports = __webpack_public_path__ + "static/img/kv.d1eb24a1.png";